import React, { useState, useMemo } from "react";
import { useBotStore } from "../../stores/botStore";
import AddRequestModal from "./AddRequestModal";
import { DeleteButton, useConfirmationStore } from "components";

// Компонент відображення таблиці "Очікування"
const CancellationQueueTable = ({
  managers,
  getManagerName,
  getStatusBadge,
  getTypeBadge,
  formatDate,
}) => {
  const cancellationQueue = useBotStore((state) => state.cancellationQueue);
  const deleteQueueRequest = useBotStore((state) => state.deleteQueueRequest);
  const isLoading = useBotStore((state) => state.isLoading);

  const { showConfirmation } = useConfirmationStore.getState();
  const [showAddModal, setShowAddModal] = useState(false);

  const managerOptions = useMemo(() => {
    return managers.map((m) => ({
      value: m.manager_id,
      label: `${m.manager_name} (ID: ${m.manager_id})`,
    }));
  }, [managers]);

  // Функція для видалення запиту
  const handleDelete = (id) => {
    showConfirmation({
      title: "Підтвердження видалення",
      message: "Ви дійсно хочете скасувати цей запит?",
      onConfirm: async () => {
        await deleteQueueRequest(id);
      },
    });
  };

  // Функція для форматування опису
  const formatDescription = (type, description) => {
    if (!description) return "-";
    const desc =
      typeof description === "string" ? JSON.parse(description) : description;

    if (type === "clean")
      return desc.manager_id ? `Менеджер: ${getManagerName(desc.manager_id)}` : "-";
    if (type === "change") {
      if (desc.manager_id && desc.new_manager_id)
        return `З менеджера ${getManagerName(desc.manager_id)} на ${getManagerName(desc.new_manager_id)}`;
      if (desc.manager_id) return `Менеджер: ${getManagerName(desc.manager_id)}`;
    }
    return "-";
  };

  return (
    <div id="queue-table-container" className="botsettings-table">
      <div className="table-title">
        <h3>Очікування видалення</h3>
        <button className="focus-button" onClick={() => setShowAddModal(true)}>
          + Додати запит
        </button>
      </div>

      <table className={`queue-table ${isLoading ? "table-loading" : ""}`}>
        <thead>
          <tr>
            <th>Автор</th>
            <th>ID замовлення</th>
            <th>Тип</th>
            <th>Опис</th>
            <th>Статус</th>
            <th>Створено</th>
            <th>Оброблено</th>
            <th>Дії</th>
          </tr>
        </thead>
        <tbody>
          {cancellationQueue.length === 0 && !isLoading ? (
            <tr>
              <td colSpan={8} className="empty-row">
                Немає записів
              </td>
            </tr>
          ) : (
            cancellationQueue.map((item) => {
              const desc =
                typeof item.description === "string"
                  ? JSON.parse(item.description)
                  : item.description;
              return (
                <tr key={item.id}>
                  <td>{item.username || item.user_id || "-"}</td>
                  <td>{desc?.order_id || "-"}</td>
                  <td>{getTypeBadge(item.type)}</td>
                  <td>{formatDescription(item.type, item.description)}</td>
                  <td>{getStatusBadge(item.status)}</td>
                  <td>{formatDate(item.created_at)}</td>
                  <td>{formatDate(item.processed_at)}</td>
                  <td>
                    {item.status === "pending" && (
                      <DeleteButton
                        onDelete={() => handleDelete(item.id)}
                        disabled={isLoading}
                      />
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      <AddRequestModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        managerOptions={managerOptions}
      />
    </div>
  );
};

export default CancellationQueueTable;
